module.exports = __webpack_public_path__ + "img/arrow-right-green.a2108f62.svg";